"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlarmPriorityCell = AlarmPriorityCell;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@iconify/react");
function AlarmPriorityCell(props) {
    var priority = props.priority;
    var isHigh = (priority === null || priority === void 0 ? void 0 : priority.toLowerCase()) === "high";
    return ((0, jsx_runtime_1.jsxs)("span", { className: "inline-flex items-center gap-1.5 text-sm font-medium ".concat(isHigh ? "text-red-600" : "text-medium-gray"), children: [isHigh && (0, jsx_runtime_1.jsx)(react_1.Icon, { icon: "solar:danger-triangle-linear", fontSize: 16 }), priority !== null && priority !== void 0 ? priority : "—"] }));
}
